import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Flame, Swords } from 'lucide-react';

export const GamificacionCard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/gamification/me`);
        setStats(data);
      } catch (e) { console.error(e); }
    })();
  }, []);

  if (!stats) return null;

  const { nivel, siguiente_nivel, xp, xp_para_siguiente, progreso_pct, racha_actual, racha_maxima, insignias, contadores } = stats;
  const conseguidas = insignias.filter(i => i.conseguida);

  return (
    <div
      className="podium-zone rounded-2xl border border-gold/30 p-4 mb-6"
      data-testid="gamificacion-card"
    >
      {/* Nivel + XP */}
      <div className="flex items-center gap-4">
        <div
          className="w-16 h-16 rounded-full flex flex-col items-center justify-center flex-shrink-0"
          style={{
            background: 'radial-gradient(circle at 35% 30%, rgba(253,224,71,0.25), rgba(0,0,0,0.6))',
            boxShadow: '0 0 0 3px #D4AF37, 0 0 24px rgba(212,175,55,0.4)',
          }}
          data-testid="gamificacion-nivel-circulo"
        >
          <span className="text-2xl font-black text-gold leading-none">{nivel.numero}</span>
          <span className="text-[8px] uppercase tracking-wider text-gray-300 font-bold">nivel</span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <Swords className="w-4 h-4 text-gold" />
            <h3 className="text-lg font-black text-white uppercase tracking-wider" data-testid="gamificacion-dios">
              {nivel.nombre}
            </h3>
          </div>
          <p className="text-xs text-gray-400 mt-0.5">
            <b className="text-gold">{xp} XP</b>
            {siguiente_nivel && (
              <> · faltan <b className="text-white">{xp_para_siguiente} XP</b> para {siguiente_nivel.nombre}</>
            )}
            {!siguiente_nivel && <> · ¡Nivel máximo alcanzado! ⚡</>}
          </p>
          {/* Barra de progreso */}
          <div className="mt-2 h-2 rounded-full bg-black/50 overflow-hidden border border-gray-700/50">
            <div
              className="h-full rounded-full transition-all"
              style={{
                width: `${Math.max(progreso_pct, 3)}%`,
                background: 'linear-gradient(90deg, #B8960B, #D4AF37, #fde047)',
                boxShadow: '0 0 8px rgba(212,175,55,0.6)',
              }}
              data-testid="gamificacion-xp-bar"
            />
          </div>
        </div>
      </div>

      {/* Racha + contadores */}
      <div className="flex items-center gap-4 mt-4 flex-wrap">
        <div className="flex items-center gap-1.5" data-testid="gamificacion-racha">
          <Flame className={`w-4 h-4 ${racha_actual > 0 ? 'text-orange-400' : 'text-gray-600'}`} />
          <span className="text-sm font-bold text-white">{racha_actual}</span>
          <span className="text-[10px] text-gray-400 uppercase">racha</span>
          {racha_maxima > 0 && <span className="text-[10px] text-gray-500">(máx {racha_maxima})</span>}
        </div>
        <div className="text-[10px] text-gray-400">
          <b className="text-white">{contadores.entrenos}</b> entrenos · <b className="text-white">{contadores.prs}</b> récords · <b className="text-white">{contadores.retos}</b> retos
        </div>
      </div>

      {/* Insignias */}
      <div className="mt-4">
        <p className="text-[10px] uppercase tracking-widest text-gold font-bold mb-2">
          Insignias · {conseguidas.length}/{insignias.length}
        </p>
        <div className="grid grid-cols-5 gap-2" data-testid="gamificacion-insignias">
          {insignias.map(ins => (
            <div
              key={ins.codigo}
              className={`flex flex-col items-center gap-0.5 py-2 px-1 rounded-xl border text-center transition-all ${
                ins.conseguida
                  ? 'bg-gold/10 border-gold/40'
                  : 'bg-black/30 border-gray-800 opacity-40 grayscale'
              }`}
              title={`${ins.nombre}: ${ins.desc}${ins.conseguida ? ` (conseguida ${ins.fecha})` : ''}`}
              data-testid={`insignia-${ins.codigo}`}
            >
              <span className="text-xl leading-none">{ins.emoji}</span>
              <span className="text-[7px] text-gray-300 font-bold leading-tight">{ins.nombre}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
